document.addEventListener("DOMContentLoaded", () => {

    const cta = document.getElementById("vhMobileCTA");
    if (!cta) return;

    const button = cta.querySelector(".vh-mobile-cta__button");
    const label = cta.querySelector(".vh-mobile-cta__text");
    const icon = cta.querySelector(".vh-mobile-cta__icon");

    let lastFreeShipping = false;

    const hero =
        document.querySelector("#vhydraHero") ||
        document.querySelector(".vhydra-hero") ||
        document.querySelector(".vhydra-hero-section");

    const builder =
        document.querySelector("#vhb-builder") ||
        document.querySelector(".vhb-builder") ||
        document.querySelector("[data-vhb-builder]");

    function updateCTAVisibility(){

        if(!hero || !builder){
            cta.classList.add("is-visible");
            return;
        }

        const heroBottom = hero.getBoundingClientRect().bottom;
        const builderTop = builder.getBoundingClientRect().top;

        const heroFinished = heroBottom <= 0;
        const builderVisible = builderTop <= window.innerHeight * 0.6;

        if(heroFinished && !builderVisible){
            cta.classList.add("is-visible");
        }else{
            cta.classList.remove("is-visible");
        }

    }

    updateCTAVisibility();

    window.addEventListener("scroll", updateCTAVisibility, { passive:true });
    window.addEventListener("resize", updateCTAVisibility);

    button.addEventListener("click", () => {

        if(builder){

            builder.scrollIntoView({

                behavior:"smooth",
                block:"start"

            });

            setTimeout(() => {

    const firstCard =
        builder.querySelector(".vhb-card");

    if(!firstCard) return;

    firstCard.classList.remove("is-highlight");

    requestAnimationFrame(() => {

        firstCard.classList.add("is-highlight");

        const addButton =
    firstCard.querySelector(".vhb-card__button");

if(addButton){

    addButton.classList.remove("is-guide");

    requestAnimationFrame(()=>{

        addButton.classList.add("is-guide");

    });

}

    });

}, 500);

        }

    });

    document.addEventListener("vhb:stateChanged", (event)=>{

        if(!label) return;

        const state = event.detail;

        const money = new Intl.NumberFormat("pt-BR",{

            style:"currency",
            currency:"BRL"

        }).format(state.subtotal / 100);

        let text = "Escolha seus sabores";

if(state.quantity === 1){

    text = "🚚 Falta 1 caixa para Frete Grátis";

}

else if(state.quantity >= 2){

    text = "🚚 Frete Grátis Liberado ✓";

}

if(state.quantity >= 3){

    text = "💜 Pedido pronto para finalizar";

}

        label.classList.remove("is-changing");

        requestAnimationFrame(()=>{

            label.classList.add("is-changing");
            label.textContent = text;

        });

        if(icon){

            icon.classList.remove("is-pop");

            requestAnimationFrame(()=>{

                icon.classList.add("is-pop");

            });

        }

        if(state.freeShipping && !lastFreeShipping){

            cta.classList.remove("is-success");

            requestAnimationFrame(()=>{

                cta.classList.add("is-success");

            });

        }

        lastFreeShipping = state.freeShipping;

    });

});